import React, { useState } from "react";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";

import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import profile_phone from "../assets/images/profile-phone.png";
import profile_date from "../assets/images/profile-date.png";
import change_password from "../assets/images/change-password.png";
import logout from "../assets/images/logout.png";
import delete_acc from "../assets/images/delete-acc.png";
import Header from "../components/Header";
import EditProfile from "../components/EditProfile";
import ChangePassword from "../components/ChangePassword";
import AuthService from "../services/AuthService";

const Profile = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const handleLogout = () => {
    AuthService.logout();
    toast.success("Logged out successfully");
    navigate("/login");
  };

  const handleDeleteAccount = async () => {
    if (window.confirm("Are you sure you want to delete your account? This action cannot be undone.")) {
      try {
        const response = await ApiService.request({
          method: "DELETE",
          url: "/profile/delete"
        });

        if (response.data.status) {
          toast.success(response.data.message);
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          navigate("/login");
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Account deletion error:", error);
        toast.error("Failed to delete account");
      }
    }
  };

  const handleProfileUpdate = (updatedUser) => {
    // setUser(updatedUser);
    updatedUser.auth_token = user.auth_token;
    // console.log(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));
  };


 
  return (
    <div className="main-heading  container">
      
      
      <Header title={'Profile'} />

      {/* Edit Profile Modal */}
      <EditProfile
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        user={user}
        onUpdate={handleProfileUpdate}
      />

      {/* Change Password Modal */}
      <ChangePassword
        isOpen={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
      />



      <div className="rounded-5 mb-5 bg-white p-4 shadow-sm mx-4">
        <div className="d-flex align-items-center gap-3 justify-content-center">
          <img
            src={user?.picture}
            alt="Profile Photo"
            className="rounded-circle"
            style={{ width: "80px", height: "80px", objectFit: "cover" }}
          />
          <div>
            <h5 className="fw-bold mb-1">{user.name} </h5>
            <p className="text-muted m-0">{user.email}</p>
          </div>
        </div>

        <div className="mt-4 d-flex justify-content-center">
          <button
            className="btn"
            style={{
              backgroundColor: "#D1FADF",
              color: "#1C1C1C",
              border: "1px solid #ABEFC6",
              borderRadius: "999px",
              padding: "10px 24px",
              fontWeight: "600",
              fontSize: "16px",
            }}
             onClick={() => setShowEditModal(true)}
          >
            Edit Your Profile
            <i
              className="bi bi-pencil-fill ms-2"
              style={{ fontSize: "16px" }}
            ></i>
          </button>
        </div>
      </div>

      <div>
           

          <div  className="d-flex justify-content-between align-items-center border-top border-bottom" >
            <div className="d-flex justify-content-start align-items-center px-3 py-2">
              <img
                src={profile_phone}
                alt="phone"
                className="mx-3"
                style={{ width: "20px", height: "20px" }}
              />

              <p
                className={`mt-3 fs-6`}
              >
                {user.phone}
              </p>
            </div>
          </div>
          <div  className="d-flex justify-content-between align-items-center border-top border-bottom" >
            <div className="d-flex justify-content-start align-items-center px-3 py-2">
              <img
                src={profile_date}
                alt="profile_date"
                className="mx-3"
                style={{ width: "20px", height: "20px" }}
              />

              <p
                className={`mt-3 fs-6`}
              >
                {user?.age}
              </p>
            </div>
          </div>

          <div  className="d-flex justify-content-between align-items-center border-top border-bottom cursor-pointer"
            onClick={() => setShowPasswordModal(true)} >
            <div className="d-flex justify-content-start align-items-center px-3 py-2">
              <img
                src={change_password}
                alt="profile_date"
                className="mx-3"
                style={{ width: "20px", height: "20px" }}
              />

              <p
                className={`mt-3 fs-6`}
              >
                Change Password
              </p>
            </div>
            <div>
              <MdKeyboardArrowRight fontSize={30} className="me-3" />
            </div>
          </div>

          <div  className="d-flex justify-content-between align-items-center border-top border-bottom cursor-pointer"
            onClick={handleLogout} >
            <div className="d-flex justify-content-start align-items-center px-3 py-2">
              <img
                src={logout}
                alt="profile_date"
                className="mx-3"
                style={{ width: "20px", height: "20px" }}
              />

              <p
                className={`mt-3 fs-6`}
              >
                Logout
              </p>
            </div>
            <div>
              <MdKeyboardArrowRight fontSize={30} className="me-3" />
            </div>
          </div>

          <div  className="d-flex justify-content-between align-items-center border-top border-bottom cursor-pointer" 
            onClick={handleDeleteAccount}>
            <div className="d-flex justify-content-start align-items-center px-3 py-2">
              <img
                src={delete_acc}
                alt="profile_date"
                className="mx-3"
                style={{ width: "20px", height: "20px" }}
              />

              <p
                className={`mt-3 fs-6 text-danger`}
              >
                Delete Account
              </p>
            </div>
            <div>
              <MdKeyboardArrowRight fontSize={30} className="me-3" />
            </div>
          </div>


      </div>
    </div>
  );
};

export default Profile;
